<template>
    <div :class="propertyTypeInputClass">
        <p v-html="selectedLabel" class="text-left"></p>

        <!-- Delivery address property type radio field -->
        <div class="input__radio">
            <input
                id="delivery-address-property-type-house"
                name="delivery-address-property-type"
                class="input__radio-item"
                type="radio"
                value="house"
                v-model="propertyType">
            <label class="input__radio-label" for="delivery-address-property-type-house"
                v-html="$t('DELIVERY_ADDRESS_PROPERTY_FIELD_HOUSE')"></label>
        </div>

        <!-- Delivery address property type radio field -->
        <div class="input__radio">
            <input
                id="delivery-address-property-type-flat"
                name="delivery-address-property-type"
                class="input__radio-item"
                type="radio"
                value="flat"
                v-model="propertyType">
            <label class="input__radio-label" for="delivery-address-property-type-flat"
                v-html="$t('DELIVERY_ADDRESS_PROPERTY_FIELD_FLAT')"></label>
        </div>

        <!-- Delivery address property type radio field -->
        <div class="input__radio">
            <input
                id="delivery-address-property-type-office"
                name="delivery-address-property-type"
                class="input__radio-item"
                type="radio"
                value="office"
                v-model="propertyType">
            <label class="input__radio-label" for="delivery-address-property-type-office"
                v-html="$t('DELIVERY_ADDRESS_PROPERTY_FIELD_OFFICE')"></label>
        </div>

        <!-- Validation -->
        <p class="input__message" v-if="showRequiredValidationMessage"
            v-html="$t('DELIVERY_ADDRESS_PROPERTY_FIELD_JUST_TO')"></p>
    </div>
</template>
<script>
import requiredIf from 'vuelidate/src/validators/requiredIf';

export default {
    name: 'DeliveryAddressPropertyTypeField',
    props: {
        require: {
            default: false,
            type: Boolean,
        },
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            propertyType: null,
            selectedLabel: null,
        };
    },
    mounted() {
        this.propertyType = this.value;
        this.selectedLabel = this.label || this.$t('DELIVERY_ADDRESS_PROPERTY_FIELD_WHAT_KIND_OF_BUILDING');
    },
    computed: {
        isPropertyTypeValid() {
            return !this.$v.$invalid;
        },

        isRequired() {
            return this.require;
        },

        propertyTypeInputClass() {
            return this.isPropertyTypeValid ? 'input' : 'input input--invalid';
        },

        showRequiredValidationMessage() {
            return this.propertyType !== null && !this.$v.propertyType.required;
        },
    },
    methods: {
        /**
         * Sync with parent component.
         *
         * @returns {void}
         */
        updateInput() {
            this.$v.$touch();

            this.$emit('input', this.propertyType);
        },
    },
    validations: {
        propertyType: {
            required: requiredIf('isRequired'),
        },
    },
    watch: {
        propertyType() {
            this.updateInput();
        },
        value(newValue) {
            if (newValue !== this.propertyType) {
                this.propertyType = newValue;
            }
        },
    },
};
</script>
